import React from 'react';
import { Typography } from '@mui/material';
import Services from '../components/offer/Services';
import Steps from '../components/offer/Steps';
import Sustainability from '../components/offer/Sustainability';
import HalfByHalf from '../components/global/HalfByHalf';
import { useTranslation } from 'react-i18next';
import Seo from '../components/seo/Seo';
const Offer = () => {
  const { t } = useTranslation('offer');
  const title = `Betonoki - ${t('offer')}`;
  const description =
    t('metaDescription', {
      defaultValue:
        'Zakres usług Betonoki: projektowanie, BIM, zrównoważone budownictwo oraz wizualizacje i VR.',
    });
  return (
    <>
      <Seo title={title} description={description} path="/offer" image="/img/offer/bim/bim3.jpg" />
      <Typography variant="h1">
        {t('offer')}
      </Typography>

      <Steps/>

      <Services />

      <Sustainability />

      <HalfByHalf src={'/img/offer/bim/bim3.jpg'} direction={'left'} alt='BIM' minHeight="800px" ratio={[7,3]} contain={true}>
        <Typography variant="h5" sx={{ margin: '0 0 2rem 0' }}>
          {t('bimLabel')}
        </Typography> 
        <Typography paragraph>
          {t('bimDescription1')}
        </Typography>
        <Typography paragraph>
          {t('bimDescription2')}
        </Typography>
      </HalfByHalf>


      <HalfByHalf src={'/img/offer/virtual/virtual.jpg'} direction={'right'} alt='Virtual reality'>
        <Typography variant="h5" sx={{ margin: '0 0 2rem 0' }}>
          {t('vrLabel')}
        </Typography>
        <Typography paragraph>
          {t('vrDescription')}
        </Typography>
        <ul>
          <li>{t('vrList.3dModelsVisualizations')}</li>
          <li>{t('vrList.interiorDesignsVisualizations')}</li>
          <li>{t('vrList.marketingVisualizations')}</li>
          <li>{t('vrList.interactiveWalkthroughs')}</li>
          <li>{t('vrList.vrPresentation')}</li>
        </ul>
      </HalfByHalf>
    </>
  );
};

export default Offer;
